module.exports = __webpack_public_path__ + "img/position_user.d657b78a.png";